/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ActivityItem from './ActivityItem';

/**
 * The NewActivityResponse model module.
 * @module model/NewActivityResponse
 * @version 1.0.0
 */
class NewActivityResponse {
    /**
     * Constructs a new <code>NewActivityResponse</code>.
     * @alias module:model/NewActivityResponse
     */
    constructor() { 
        
        NewActivityResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NewActivityResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NewActivityResponse} obj Optional instance to populate.
     * @return {module:model/NewActivityResponse} The populated <code>NewActivityResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NewActivityResponse();

            if (data.hasOwnProperty('general')) {
                obj['general'] = ApiClient.convertToType(data['general'], [ActivityItem]);
            }
            if (data.hasOwnProperty('company_search')) {
                obj['company_search'] = ApiClient.convertToType(data['company_search'], [ActivityItem]);
            }
            if (data.hasOwnProperty('search_is_open')) {
                obj['search_is_open'] = ApiClient.convertToType(data['search_is_open'], 'Boolean');
            }
            if (data.hasOwnProperty('count_general')) {
                obj['count_general'] = ApiClient.convertToType(data['count_general'], 'Number');
            }
            if (data.hasOwnProperty('count_company_search')) {
                obj['count_company_search'] = ApiClient.convertToType(data['count_company_search'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/ActivityItem>} general
 */
NewActivityResponse.prototype['general'] = undefined;

/**
 * @member {Array.<module:model/ActivityItem>} company_search
 */
NewActivityResponse.prototype['company_search'] = undefined;

/**
 * @member {Boolean} search_is_open
 */
NewActivityResponse.prototype['search_is_open'] = undefined;

/**
 * @member {Number} count_general
 */
NewActivityResponse.prototype['count_general'] = undefined;

/**
 * @member {Number} count_company_search
 */
NewActivityResponse.prototype['count_company_search'] = undefined;






export default NewActivityResponse;

